import { render, staticRenderFns } from "./UserHistoryModal.vue?vue&type=template&id=0e729931&"
import script from "./UserHistoryModal.vue?vue&type=script&lang=js&"
export * from "./UserHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports